import type { IAdminOrganizationRepository } from "@/application/ports/repositories";
import type {
	AdminOrganization,
	OrgDraftCreateRequest,
	AdminOrganizationMember,
	AdminOrganizationInvitation,
} from "@/domain/admin";
import { apiClient } from "../client";

export class AdminOrganizationRepository
	implements IAdminOrganizationRepository
{
	private basePath = "/admin/organizations";

	async getOrganizations(): Promise<AdminOrganization[]> {
		const response = await apiClient.get<AdminOrganization[]>(this.basePath);
		return response.data;
	}
	async getOrganization(uuid: string): Promise<AdminOrganization> {
		const response = await apiClient.get<AdminOrganization>(
			`${this.basePath}/${uuid}`,
		);
		return response.data;
	}
	async createOrganization(
		data: OrgDraftCreateRequest,
	): Promise<AdminOrganization> {
		const response = await apiClient.post<AdminOrganization>(
			this.basePath,
			data,
		);
		return response.data;
	}
	async updateOrganization(
		uuid: string,
		data: Partial<AdminOrganization>,
	): Promise<AdminOrganization> {
		const response = await apiClient.patch<AdminOrganization>(
			`${this.basePath}/${uuid}`,
			data,
		);
		return response.data;
	}
	async deleteOrganization(uuid: string): Promise<void> {
		await apiClient.delete(`${this.basePath}/${uuid}`);
	}
	async getOrganizationMembers(
		organizationUuid: string,
	): Promise<AdminOrganizationMember[]> {
		const response = await apiClient.get<AdminOrganizationMember[]>(
			`${this.basePath}/${organizationUuid}/members`,
		);
		return response.data;
	}
	async getOrganizationInvitations(
		organizationUuid: string,
	): Promise<AdminOrganizationInvitation[]> {
		const response = await apiClient.get<AdminOrganizationInvitation[]>(
			`${this.basePath}/${organizationUuid}/invitations`,
		);
		return response.data;
	}
}
